import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, MenuItem, OutlinedInput, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
// import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { MobileDatePicker } from '@mui/x-date-pickers';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import Page from '../../../../component/Page';
import TitlePage from '../../../../component/TitlePage';
import DatePicker from '../../../../component/DatePicker';
import { addDiscardSeed, getDiscardItemMasterList, getItemDiscardBalanceList, getItemMasterList, getMaterialsList, getZones } from '../../services/api';
import { GetBreedClassNo, GetSeasonNo } from '../../services/stockService';
import ConfirmDialog from '../component/ConfirmDialog'
import RequireField from '../../../../component/RequireField';
import { getMaterialsRawList } from '../../../raw/services/api';

var buddhistEra = require('dayjs/plugin/buddhistEra')
dayjs.extend(buddhistEra)

export default function StockCulledAdd() {
    const { profile, loading } = useSelector(state => state.profile)

    const navigate = useNavigate();
    const [refNoError, setRefNoError] = useState(false)
    const [senderOrReceiverError, setSenderOrReceiverError] = useState(false)
    const [senderOrReceiver, setSenderOrReceiver] = useState('กลุ่มผลิตเมล็ดพันธ์ุ(งานโรงงาน)')
    const [source, setSource] = useState('')
    const [documentDate, setDocumentDate] = useState(dayjs(new Date()))
    const [items, setItems] = useState([])
    const [materials, setMaterials] = useState([])
    const [branchs, setBranchs] = useState([])
    const [name, setName] = useState('')
    const [open, setOpen] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [documentType, setDocumentType] = useState('รับ');
    const [seedType, setSeedType] = useState('ใช้ประโยชน์ได้');

    const [rows, setRows] = useState([
        {
            RefNo: "",
            ItemNo: null,
            Year: null,
            Lot: "",
            MaterialNo: "",
            MaterialQty: null,
            Qty: null,
            WarehouseNo: "",
            ZoneNo: "",
            Remark: ""
        }
    ]);
    function addRow() {
        const newRow = {
            RefNo: "",
            ItemNo: null,
            Year: null,
            Lot: "",
            MaterialNo: "",
            MaterialQty: null,
            Qty: null,
            WarehouseNo: "",
            ZoneNo: "",
            Remark: ""
        };

        setRows([...rows, newRow]);
    }
    const deletehand = (i) => {
        const data = rows?.filter((e, index) => i !== index);
        setRows(data);
    };

    useEffect(() => {
        const getZonesList = async () => {
            const data = await getZones(profile?.BranchNo?.BranchNo)
            setBranchs(data)
        }
        getZonesList()
    }, [profile])

    useEffect(() => {

        const getItemMaterials = async () => {
            const data = await getDiscardItemMasterList()
            setItems(data)
        }
        const getItemDiscardBalance = async () => {
            const data = await getItemDiscardBalanceList(profile?.BranchNo?.BranchNo)
            setItems(data)
        }
        if (documentType === 'รับ') {
            getItemMaterials()
        } else {
            getItemDiscardBalance()
        }


    }, [documentType])
    useEffect(() => {
        const getMaterials = async () => {
            const data = await getMaterialsRawList()
            setMaterials(data)
        }
        getMaterials()
    }, [])

    const handleSubmit = (e) => {
        if (!senderOrReceiver) {
            setSenderOrReceiverError(true)
        }

        if (rows?.filter((x) => !x?.ItemNo)) {
            const item = rows?.map((v, index) => {
                v.LotError = v.ItemNo ? false : true
                return v;

            });
            setRows([...item]);
        }
        if (rows?.filter((x) => x?.Year?.length < 1)) {
            const item = rows?.map((v, index) => {
                v.YearError = v?.Year?.length >= 1 ? false : true
                return v;

            });
            setRows([...item]);
        }

        // if (rows?.filter((x) => x?.Lot?.length < 3)) {
        //     const item = rows?.map((v, index) => {
        //         v.LotGenError = v.Lot?.length >= 3 ? false : true
        //         return v;

        //     });
        //     setRows([...item]);
        // }
        if (rows?.filter((x) => x?.WarehouseNo?.length < 1)) {
            const item = rows?.map((v, index) => {
                v.WarehouseError = v.WarehouseNo ? false : true
                return v;

            });
            setRows([...item]);
        }
        if (senderOrReceiver && rows?.filter((x) => !x?.ItemNo).length === 0 && rows?.filter((x) => x?.Year?.length < 1).length === 0 && rows?.filter((x) => x?.WarehouseNo?.length < 1).length === 0) {
            setOpen(true)
        }
    }
    const handleAdd = () => {

        const body = {
            DocumentDate: dayjs(documentDate).format('YYYY-MM-DD'),
            DocumentType: documentType,
            BranchNo: profile?.BranchNo?.BranchNo,
            SenderOrReceiver: senderOrReceiver,
            Source: source,
            SeedCategory: seedType,
            Status: "Y",
            Details: rows?.map((x) => (
                {

                    RefNo: x?.RefNo,
                    ItemNo: x?.ItemNo?.ItemNo,
                    Year: x?.Year,
                    Lot: x?.LotGen + x?.Lot,
                    MaterialNo: x?.MaterialNo,
                    MaterialQty: +x?.MaterialQty.toString().replaceAll(',', ''),
                    Qty: +x?.Qty.toString().replaceAll(',', ''),
                    WarehouseNo: x?.WarehouseNo,
                    ZoneNo: x?.ZoneNo,
                    Remark: x?.Remark
                }
            ))
        }
        const post = async () => {
            const res = await addDiscardSeed(body)
            if (res) {
                setLoadingSubmit(false)
                setOpen(false)
                navigate('/stock/stock-culled/' + res.DocumentNo, { state: { new: true } })
            } else {
                Swal.fire({
                    title: 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
                setLoadingSubmit(false)
            }
        }
        post()
    }
    const getLastLot = async (prefix) => {

        let _params = '';

        if (prefix) {
            _params = '?prefix=' + prefix;
        }
        // await getData(STOCK_CONFIG.requests.getLastLot.url + _params).then((response) => {
        //     if (response.status === true) {
        //         setLastLot(response.result)
        //     }
        // })
    }

    return (
        <Page>
            <TitlePage title='ข้อมูลเมล็ดพันธุ์' />

            <div class="row" style={{ width: '80%' }}>

                {/* <Box class="col-lg-5 col-md-6">
                    <Typography class="labelInput">ประเภททำรายการ</Typography>
                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                        <FormControl variant="standard" fullWidth >
                            <Select value={documentType}
                                disableUnderline
                                onChange={e => setDocumentType(e.target.value)}
                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                            >
                                <MenuItem value='รับ'>รับ</MenuItem>
                                <MenuItem value='จ่าย'>จ่าย</MenuItem>

                            </Select>
                        </FormControl>
                    </Box>
                </Box> */}
                <Box class="col-lg-5 col-md-6">
                    <Typography class="labelInput">วันที่ทำรายการ</Typography>
                    <DatePicker value={documentDate} onChange={e => setDocumentDate(e)} />

                </Box>
                <Box class="col-lg-5 col-md-6">

                </Box>
                {documentType === 'รับ' ?
                    <>
                        <Box class="col-lg-5 col-md-6">
                            <Typography class="labelInput">รับจาก</Typography>
                            {/* <Box className={`backgroundField ${senderOrReceiverError ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
                                <TextField required value={senderOrReceiver}
                                    onBlur={e => {
                                        if (!e.target.value) {
                                            setSenderOrReceiverError(true)
                                        } else {
                                            setSenderOrReceiverError(false)
                                        }
                                    }} 
                                    onChange={e => setSenderOrReceiver(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                            {senderOrReceiverError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาที่รับ</span>} */}
                            <RequireField value={senderOrReceiver} onChange={setSenderOrReceiver} type={'text'} disabled={false} error={senderOrReceiverError} setError={setSenderOrReceiverError} textError={'กรุณาที่รับ'} />

                        </Box>
                        <Box class="col-lg-5 col-md-6">
                            <Typography class="labelInput">ชื่อโรงงาน</Typography>
                            <Box className={`backgroundField ${refNoError ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
                                <TextField required value={source}
                                    //  onBlur={e => {
                                    //     if (!e.target.value) {
                                    //         setRefNoError(true)
                                    //     } else {
                                    //         setRefNoError(false)
                                    //     }
                                    // }} 
                                    onChange={e => setSource(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                            {/* {refNoError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกเลขที่อ้างอิง</span>} */}
                        </Box>
                    </> :
                    <Box class="col-lg-5 col-md-6">
                        <Typography class="labelInput">จ่ายให้</Typography>
                        <Box className={`backgroundField ${refNoError ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
                            <TextField required value={senderOrReceiver}
                                //  onBlur={e => {
                                //     if (!e.target.value) {
                                //         setRefNoError(true)
                                //     } else {
                                //         setRefNoError(false)
                                //     }
                                // }}
                                onChange={e => setSenderOrReceiver(e.target.value)} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                }}
                            />
                        </Box>
                        {/* {refNoError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกเลขที่อ้างอิง</span>} */}
                    </Box>}

            </div>
            <Box class="col-lg-5 col-md-12">
                <Typography class="labelInput">ประเภทเมล็ดพันธุ์</Typography>
                <RadioGroup row
                    value={seedType}
                    onChange={e => setSeedType(e.target.value)}
                >
                    <FormControlLabel value={"ใช้ประโยชน์ได้"} control={<Radio />} label="เมล็ดพันธุ์คัดออกใช้ประโยชน์ได้" />
                    {/* <FormControlLabel value={'ใช้ประโยชน์ไม่ได้'} control={<Radio />} label="เมล็ดพันธุ์ใช้ประโยชน์ไม่ได้" /> */}
                </RadioGroup>
            </Box>
            <TitlePage title='รายการเมล็ดพันธุ์' action={
                <FontAwesomeIcon icon={faPlusCircle} onClick={addRow} />
            } />
            <div class="addDetail row">
                <div class="col-md-12 table-responsive-sm" style={{ height: 'auto', overflowX: 'auto' }}>
                    <table class="table table-borderless" style={{ width: '1800px' }}>
                        <thead>
                            <tr>
                                <th class="text-center" style={{ width: '180px' }}>เลขที่อ้างอิง</th>
                                <th class="text-center ">เมล็ดพันธุ์</th>
                                <th class="text-center" >ชั้นพันธุ์</th>

                                <th class="text-center" >ฤดู</th>
                                <th class="text-center" >ปีที่ผลิต</th>

                                {/* <th class="text-center" >ล็อตที่</th> */}
                                <th class="text-center" >ประเภทบรรจุภัณฑ์</th>

                                <th class="text-center" >จำนวน (กระสอบ)</th>
                                <th class="text-center" >ปริมาณ (กิโลกรัม)</th>
                                <th class="text-center" >ปริมาณเฉลี่ย/กระสอบ</th>
                                <th class="text-center" >โรงเก็บที่</th>
                                <th class="text-center" >หมายเหตุ</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody class="">
                            {rows?.map((x, i) => (
                                <tr >
                                    <td>
                                        <TextField value={x?.RefNo || ''}
                                            sx={{ background: '#fff', width: "100%" }}
                                            size='small' fullWidth variant='outlined'
                                            onChange={e => {
                                                const item = rows?.map((v, index) => {
                                                    v.RefNo = index === i ? e.target.value : v?.RefNo;
                                                    return v;

                                                });
                                                setRows(item);
                                            }}
                                        />
                                    </td>
                                    <td style={{ position: 'relative' }}>
                                        <Autocomplete
                                            size='small'
                                            options={items}
                                            getOptionLabel={(option) => option?.ItemName}
                                            onBlur={e => {
                                                const item = rows?.map((v, index) => {
                                                    v.LotError = index === i ? x.ItemNo ? false : true : v?.LotError;
                                                    return v;
                                                });
                                                setRows([...item]);
                                            }
                                            }
                                            componentsProps={{
                                                paper: {
                                                    sx: {
                                                        width: 500
                                                    }
                                                }
                                            }}
                                            renderOption={(props, option) => (
                                                <Box component="li" {...props} key={option.ItemNo}>
                                                    {option?.CatalogNo?.CatalogName} {option?.Option2} <span style={{ color: option?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.Option1}
                                                </Box>
                                            )}
                                            value={x?.ItemNo}
                                            onChange={(event, newValue) => {
                                                const item = rows?.map((v, index) => {
                                                    v.LotGen = index === i ? '000' : v?.LotGen;
                                                    v.ItemNo = index === i ? newValue : v?.ItemNo;
                                                    return v;

                                                });
                                                setRows([...item]);

                                            }}

                                            renderInput={(params) => (
                                                <Box ref={params.InputProps.ref}>
                                                    <OutlinedInput error={!x?.LotError ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: '#fff' }} />
                                                </Box>
                                            )}
                                        />
                                        {!x?.LotError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute' }}>กรุณาเลือกเมล็ดพันธุ์</span>}
                                    </td>
                                    <td class="text-center">{x?.ItemNo?.Option2}</td>
                                    <td class="text-center" style={{ color: x?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold' }}>{x?.ItemNo?.Season}
                                    </td>
                                    <td style={{ display: "block", position: 'relative' }}>
                                        {documentType === 'รับ' ? <>

                                            <TextField className='w-70' error={!x?.YearError ? false : true} onBlur={e => {
                                                const item = rows?.map((v, index) => {
                                                    v.YearError = index === i ? x.Year ? false : true : v?.YearError;
                                                    return v;

                                                });
                                                setRows([...item]);
                                            }
                                            } value={x?.Year}
                                                size='small' variant='outlined' onChange={e => {
                                                    const branchNo = profile?.BranchNo?.BranchNo
                                                    const breedClassNo = GetBreedClassNo(x?.ItemNo?.Option2)
                                                    const seasonNo = GetSeasonNo(x?.ItemNo?.Season)
                                                    const lotNumber = branchNo + breedClassNo + seasonNo + e.target.value;
                                                    const item = rows?.map((v, index) => {
                                                        v.Year = index === i ? e.target.value : v?.Year;
                                                        v.LotGen = index === i ? lotNumber : v?.LotGen
                                                        return v;

                                                    });
                                                    setRows([...item]);
                                                    getLastLot(x?.LotGen)
                                                }}
                                                sx={{ background: '#fff' }}
                                                inputProps={{ maxLength: 2 }}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} />
                                            {!x?.YearError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-8px', left: "8px" }}>กรุณากรอกปี</span>}
                                        </> :
                                            <TextField className='w-70' value={x?.ItemNo?.Year}
                                                size='small' variant='outlined'
                                                sx={{ background: '#fff' }}
                                                inputProps={{ maxLength: 2 }}
                                                disabled
                                            />}
                                    </td>

                                    {/* <td>
                                        {documentType === 'รับ' ?
                                            <div style={{ position: "relative" }}>
                                                <Box sx={{
                                                    display: 'flex', '& .MuiTextField-root': {
                                                        color: 'red',
                                                        '& .MuiOutlinedInput-root': { borderRadius: '0 .25rem .25rem 0' }
                                                    }
                                                }}>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '.375rem .75rem',
                                                        fontSize: '1rem',
                                                        fontWeight: '400',
                                                        lineHeight: '1.5',
                                                        color: '#212529',
                                                        textAlign: 'center',
                                                        whiteApace: 'nowrap',
                                                        backgroundColor: '#e9ecef',
                                                        border: '1px solid #ced4da',
                                                        borderRadius: '.25rem 0 0 .25rem',

                                                    }}>{x?.LotGen}</div>
                                                    <TextField sx={{ width: "100px" }} error={!x?.LotGenError ? false : true}
                                                        onBlur={e => {
                                                            const item = rows?.map((v, index) => {
                                                                v.LotGenError = index === i ? x.Lot.length === 3 ? false : true : v?.LotGenError;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }} value={x?.Lot}
                                                        inputProps={{ maxLength: 3 }}
                                                        size='small' fullWidth variant='outlined' onChange={e => {
                                                            const item = rows?.map((v, index) => {
                                                                v.Lot = index === i ? e.target.value : v?.Lot;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }} onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }} />

                                                </Box>
                                               
                                            </div> :
                                            <TextField value={x?.ItemNo?.Lot}
                                                size='small' variant='outlined'
                                                sx={{ background: '#fff' }}
                                                disabled
                                            />}
                                    </td> */}
                                    <td class="text-center">
                                        <FormControl className='w-120' variant="outlined" size='small' fullWidth
                                            error={x?.MaterialNoError}
                                        >
                                            <Select value={x?.MaterialNo} onChange={e => {
                                                const item = rows?.map((v, index) => {
                                                    v.MaterialNo = i === index ? e.target.value : v?.MaterialNo;
                                                    v.MaterialName = i === index ? materials?.find((x) => x?.ItemNo === e.target.value)?.ItemName : v?.MaterialName

                                                    return v;

                                                });
                                                setRows([...item]);
                                            }}
                                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}

                                                onBlur={e => {
                                                    const item = rows?.map((v, index) => {
                                                        v.MaterialNoError = index === i ? x.MaterialNo ? false : true : v?.MaterialNoError;
                                                        return v;

                                                    });
                                                    setRows([...item]);
                                                }} >
                                                {materials?.map((z, i) => {
                                                    return (
                                                        <MenuItem key={i} value={z?.ItemNo}>{z?.ItemName}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                    </td>
                                    <td class="text-center">
                                        <TextField value={x?.MaterialQty?.toLocaleString()}
                                            sx={{ background: '#fff', width: "100px" }}
                                            type='tel' size='small' fullWidth variant='outlined' onChange={e => {
                                                let newValue = e.target.value.replace(/,/g, "");

                                                let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                                const item = rows?.map((v, index) => {
                                                    v.MaterialQty = i === index ? abc : v?.MaterialQty;
                                                    v.OtyPer = i === index ? +x?.Qty?.toString().replaceAll(',', '') / +e.target.value.toString().replaceAll(',', '') : v?.OtyPer
                                                    return v;

                                                });
                                                setRows([...item]);
                                            }} onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }} />
                                    </td>
                                    <td class="text-center">
                                        <TextField value={x?.Qty?.toLocaleString()}
                                            sx={{ background: '#fff', width: "100px" }}
                                            type='tel' size='small' fullWidth variant='outlined' onChange={e => {
                                                let newValue = e.target.value.replace(/,/g, "");

                                                let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                                const item = rows?.map((v, index) => {
                                                    v.OtyPer = i === index ? +e.target.value.toString().replaceAll(',', '') / +x?.MaterialQty.toString().replaceAll(',', '') : v?.OtyPer
                                                    v.Qty = i === index ? abc : v?.Qty;
                                                    return v;

                                                });
                                                setRows([...item]);
                                            }} onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }} /></td>
                                    <td class="text-center">
                                        {x?.OtyPer ? parseFloat(x?.OtyPer).toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,") : 0}
                                    </td>
                                    <td style={{ position: "relative" }}>
                                        <FormControl className='w-120' variant="outlined" size='small' fullWidth
                                            error={x?.WarehouseError}
                                        >
                                            <Select value={x?.WarehouseNo} onChange={e => {
                                                const item = rows?.map((v, index) => {
                                                    v.WarehouseNo = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value)?.WarehouseNo.WarehouseNo : v?.WarehouseNo;
                                                    v.ZoneNo = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value).ZoneNo : v?.ZoneNo
                                                    v.WarehouseName = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value)?.WarehouseNo.WarehouseName : v?.WarehouseName
                                                    v.ZoneName = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value).ZoneName : v?.ZoneName
                                                    return v;

                                                });
                                                setRows([...item]);
                                            }} onBlur={e => {
                                                const item = rows?.map((v, index) => {
                                                    v.WarehouseError = index === i ? x.WarehouseNo ? false : true : v?.WarehouseError;
                                                    return v;

                                                });
                                                setRows([...item]);
                                            }} >
                                                {/* <MenuItem value='all' disabled>เลือกโรงเก็บ</MenuItem> */}
                                                {branchs?.map((z, i) => (
                                                    <MenuItem value={z?.ZoneNo}>{z?.WarehouseNo?.WarehouseName} {z?.ZoneName}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        {!x?.WarehouseError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-6px', left: "8px" }}>กรุณาเลือกโรงเก็บ</span>}

                                    </td>
                                    <td class="text-center">
                                        <TextField className='w-90' sx={{ width: "150px" }} value={x?.Remark} size='small' fullWidth variant='outlined' onChange={e => {

                                            const item = rows?.map((v, index) => {
                                                v.Remark = i === index ? e.target.value : v?.Remark;
                                                return v;

                                            });
                                            setRows([...item]);
                                        }}
                                        />
                                    </td>
                                    <td>
                                        <FontAwesomeIcon icon={faMinusCircle} onClick={() => deletehand(i)} />
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>
            </div>
            <hr class="chr" />
            <div class="row mt-4">
                <div class="col-12">
                    <Button onClick={() => navigate(-1)} variant='outlined'
                        startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                        sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                    <Button variant='contained' onClick={() => handleSubmit()} sx={{ width: '130px', fontSize: '14px' }}>บันทึก</Button>
                </div>
            </div>
            <ConfirmDialog open={open} setOpen={setOpen} rows={rows} handleSubmit={handleAdd} loadingSubmit={loadingSubmit} />

        </Page >
    )
}
